<template>
  <v-list dense :min-height="min_height">
    <v-list-item
      v-for="(area, i) in areas"
      :key="i"
      style="max-height: 30px !important"      
    >
      <v-list-item-avatar min-width="10" max-width="10"
        ><v-icon size="8">mdi-circle</v-icon></v-list-item-avatar
      >
      <v-list-item-title class="subtitle-2" style="white-space: unset !important">{{ area }}</v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  props: {
    areas: Array,
    min_height: Number
  },
};
</script>

<style>
</style>